export enum FileType {
  CSV = 'text/csv;charset=utf-8;',
}

/**
 * Generate a Blob from a file
 * F.e: generateBlobFromFile('Hello world', FileType.CSV)
 * @param file
 * @param fileType
 */
export const generateBlobFromFile = (file: BlobPart, fileType: FileType) => {
  return new Blob([file], { type: fileType });
};
